import {BreadcrumbBar, withMobile} from "@hps/hops-react";
import PropTypes from "prop-types";
import React from "react";

import Card from "Components/Card";
import Container from "Components/Container.js";
import Flex from "Components/Flex.js";
import Link from "Components/Link.js";
import String from "Components/String.js";

import scss from "./UiContainer.module.scss";


/**
 * UI container
 *
 * A generic inner view container.
 *
 * @package HOPS
 * @subpackage Ui
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class UiContainer extends React.PureComponent {

	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<Container
				columns={this.props.columnsOuter}
				fullWidth={true}
				gap={(this.useSingleColumnView ? 1 : 2)}
				justifyContent={this.props.justifyContent}
				maxWidth={this.props.maxWidth}
				px={(this.useSingleColumnView ? 0 : this.props.px)}
				singleColumn={this.props.singleColumn}>
				<Flex>
					{(this.props.backLabel || this.props.breadcrumbs) && <Card>
						<Flex columnar={true}>
							{this.props.backLabel && this.renderBack()}
							{this.props.breadcrumbs && <BreadcrumbBar breadcrumbs={this.props.breadcrumbs} onBreadcrumbClick={this.props.onBreadcrumbClick} />}
						</Flex>
					</Card>}
					<div className={(this.props.headerImg && scss.headerContentContainerImaged)}>
						<Flex>
							<String
								bold={true}
								str={this.props.label}
								variant="h4" />
							<String
								color="textSecondary"
								gap={0.75}
								lineHeight={1.8}
								str={this.props.intro} />
						</Flex>
						{(this.props.headerImg && this.renderImage())}
					</div>
				</Flex>
				{this.props.headerChildren}
				<Container
					alignItems={this.props.alignItems}
					columnar={!this.useSingleColumnView}
					columns={(this.props.columns || (!this.props.invertColumnOrder ? `auto ${this.props.sideColumnWidth}` : `${this.props.sideColumnWidth} auto`))}
					fullWidth={true}
					gap={(this.useSingleColumnView ? 1 : 2)}
					singleColumn={(this.useSingleColumnView || this.props.singleColumn)}>
					{this.props.children}
				</Container>
			</Container>
		);
	}


	/**
	 * Render the back link.
	 *
	 * @return {ReactNode}
	 */
	renderBack() {
		return (
			<Link
				label={this.props.backLabel}
				onClick={this.props.backClick}
				startArrow={true}
				uri={this.props.back} />
		);
	}


	/**
	 * Render the image.
	 * 
	 * @return {ReactNode}
	 */
	renderImage() {
		return (
			<img
				alt={this.props.headerImgAlt}
				className={scss.headerImg}
				src={this.props.headerImg} />
		);
	}


	/**
	 * Get whether to use the single column view layout.
	 * 
	 * @return {Boolean}
	 */
	get useSingleColumnView() {
		return !this.props.bp(this.props.singleColumnBreakpoint);
	}


	static propTypes = {
		px: PropTypes.number,
		singleColumnBreakpoint: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", false]),
		sideColumnWidth: PropTypes.string
	};

	static defaultProps = {
		px: 2,
		singleColumnBreakpoint: "md",
		sideColumnWidth: "36rem"
	};

}

export default withMobile(UiContainer);
